import { AnyAction, combineReducers } from "redux";
import { AppState } from "@shared/interfaces";
import { SharedReducer } from "@shared/store/reducer";
import { UserReducer } from "@containers/User/store/reducer";
import { SensorReducer } from "@containers/Sensor/store/reducer";
import { AuthReducer } from "@containers/Auth/store/reducer";
import { StationReducer } from "@containers/Station/store/reducer";
import { PatientReducer } from "@containers/Patient/store/reducer";
import { HospitalReducer } from "@containers/Hospital/store/reducer";
import { SensorDatafileReducer } from "@containers/SensorDataFile/store/reducer";
import { SensorDataSessionReducer } from "@containers/SensorDataSession/store/reducer";
import { SensorDataRestoringRequestReducer } from "@containers/SensorDataRestoringRequest/store/reducer";
import { AlertReducer } from "@containers/Alert/store/reducer";

export default () => {
  const appReducer = combineReducers({
    auth: AuthReducer,
    shared: SharedReducer,
    user: UserReducer,
    sensor: SensorReducer,
    station: StationReducer,
    alert: AlertReducer,
    patient: PatientReducer,
    hospital: HospitalReducer,
    sensorDataFile: SensorDatafileReducer,
    sensorDataSession: SensorDataSessionReducer,
    sensorDataRestoringRequest: SensorDataRestoringRequestReducer,
  });

  return (state: AppState | undefined, action: AnyAction) => {
    return appReducer(state, action);
  };
};
